import { Button, Input, Select } from "antd";
import { useEffect, useState } from "react";

import type { ActivityDemandConfig } from "@/views/pages/productActivity/types";

export interface AddRequirementMatchDialogProps {
    initialValue?: ActivityDemandConfig;
    onCancel?: () => void;
    onSubmit?: (value: ActivityDemandConfig) => void;
}

const inputTypeOptions = [
    { label: "文本框", value: 1 },
    { label: "单选框", value: 2 },
    { label: "多选框", value: 3 },
    { label: "地址", value: 4 },
    { label: "日期时间", value: 5 },
    { label: "多行文本框", value: 6 }
];

/** 复刻 Vue AddRequirementMatchDialog 的字段、必填和输入类型配置。 */
export default function AddRequirementMatchDialog({
    initialValue,
    onCancel,
    onSubmit
}: AddRequirementMatchDialogProps) {
    const [fieldName, setFieldName] = useState(initialValue?.fieldName || "");
    const [hasRequired, setHasRequired] = useState(Number(initialValue?.hasRequired) === 1 ? 1 : 0);
    const [inputType, setInputType] = useState(initialValue?.inputType || 1);
    const [error, setError] = useState("");

    useEffect(() => {
        setFieldName(initialValue?.fieldName || "");
        setHasRequired(Number(initialValue?.hasRequired) === 1 ? 1 : 0);
        setInputType(initialValue?.inputType || 1);
        setError("");
    }, [initialValue]);

    const submit = () => {
        const normalizedName = fieldName.trim();
        if (!normalizedName) {
            setError("请输入字段名称");
            return;
        }
        onSubmit?.({ ...initialValue, fieldName: normalizedName, hasRequired, inputType });
    };

    return (
        <div className="activity-demand-dialog" aria-label="需求字段配置">
            <div className="activity-demand-dialog__field">
                <label htmlFor="activity-demand-field-name">
                    <span className="activity-demand-dialog__required">*</span>字段名称
                </label>
                <Input
                    id="activity-demand-field-name"
                    placeholder="请输入字段名称"
                    value={fieldName}
                    onChange={event => {
                        setFieldName(event.target.value);
                        if (error) setError("");
                    }}
                />
                {error ? <div className="activity-demand-dialog__error">{error}</div> : null}
            </div>
            <div className="activity-demand-dialog__field">
                <label htmlFor="activity-demand-required">是否必填</label>
                <Select
                    id="activity-demand-required"
                    aria-label="是否必填"
                    value={hasRequired}
                    options={[
                        { label: "否", value: 0 },
                        { label: "是", value: 1 }
                    ]}
                    onChange={value => setHasRequired(Number(value))}
                />
            </div>
            <div className="activity-demand-dialog__field">
                <label htmlFor="activity-demand-input-type">输入类型</label>
                <Select
                    id="activity-demand-input-type"
                    aria-label="输入类型"
                    value={inputType}
                    options={inputTypeOptions}
                    onChange={value => setInputType(Number(value))}
                />
            </div>
            <div className="activity-demand-dialog__footer">
                <Button autoInsertSpace={false} onClick={onCancel}>
                    取消
                </Button>
                <Button autoInsertSpace={false} type="primary" onClick={submit}>
                    确认
                </Button>
            </div>
        </div>
    );
}
